<template>
  <div class="edition__font-color" v-if="notFrozenAndWithoutPossibleValues">
    <p class="form__label">Border color: {{ identifier }}</p>
    <a-form-item>
      <color-picker
          v-model="color"
          :transparency="true"
          :possibleValues="possibleColorValues"
          :allow-to-pick-any-color="!isFrozen"
          @change="handleInputChange($event)"
          @reset="handleInputReset()"
      />
    </a-form-item>
  </div>
</template>

<script>
import { possibleValuesMixin } from '@/components/project/components/form/possible-values.mixin';
import ColorPicker  from '@/components/shared/form/ColorPicker';
import { TemplateBorder } from '@/templating/TemplateBorder';

const KEY_COLOR = 'color';

export default {
  name: 'FormBorder',
  props: {
    identifier: {
      type: String,
      required: true
    },
    templateControl: {
      type: TemplateBorder,
      required: true
    },
    settings: {
      default: () => ({})
    },
    serverDefinedFrozenFields: {
      default: () => ({})
    }
    // serverDefinedPossibleValues from Mixin !
  },
  components: {
    ColorPicker
  },
  mixins: [ possibleValuesMixin ],
  data() {
    return {
      color: this.settings?.[KEY_COLOR]
    }
  },
  mounted() {
    this.bindWithPossibleValues();
    this.templateControl?.ref?.addEventListener('lang-changed', () => {
      this.bindWithPossibleValues();
    })
  },
  computed: {
    isFrozen() {
      return Boolean(this.serverDefinedFrozenFields?.color)
    },
    possibleColorValues() {
      return this.possibleValues?.[KEY_COLOR] || this.inTemplatePossibleValues?.[KEY_COLOR] || [];
    },
    // @Business: Control should NOT be displayed when it is FROZEN nad without possibleValues
    notFrozenAndWithoutPossibleValues() {
      return !(this.isFrozen && this.possibleColorValues.length === 0)
    }
  },
  methods: {
    handleInputChange(value) {
      this.$emit('change', {type: 'border', id: this.identifier, key: KEY_COLOR, value})
    },
    handleInputReset() {
      this.$emit('reset', {type: 'border', id: this.identifier, key: KEY_COLOR})
    }
  },
  watch: {
    settings(newValue) {
      if(KEY_COLOR in newValue && this.color !== newValue.color) {
        this.color = newValue.color;
      }
    }
  }
};
</script>

<style scoped lang="less">

</style>
